import React from 'react';
import Modal from '../../commonComponents/util/Modal';
import FadeOutErrorMessage from '../../commonComponents/util/FadeOutErrorMessage';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';

export default class MergeDuplicatesModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            keepRecipientId: null
        };
    }

    toggleSelectRecipient = applicantId => {
        this.setState({
            keepRecipientId: this.state.keepRecipientId === applicantId ? null : applicantId
        });
    }

    mergeRecipients = async () => {
        const keepRecipientId = this.state.keepRecipientId;
        const deleteRecipientId = this.props.duplicatesDetails.data.map(d => d.applicantId).filter(id => id !== keepRecipientId)[0];

        await this.props.mergeDuplicates(deleteRecipientId, keepRecipientId);

        if (this.props.mergingDuplicates.success) {
            if (this.props.onMergeDuplicates)
                this.props.onMergeDuplicates();

            this.onClose();
        }
    }

    onClose = () => {
        this.setState({ keepRecipientId: null });
        this.props.close();
    }

    render() {
        const { duplicatesDetails, mergingDuplicates, show } = this.props;
        const recipients = duplicatesDetails.data;
        const { keepRecipientId } = this.state;

        return (
            <Modal modalShowing={show}>
                <div className="modal-container">
                    <div className="modal merge-modal large-modal">
                        <div className="modal-header">
                            <h4 className="page-header">Merge Duplicates</h4>
                            <i className="icon ion-ios-close-empty" onClick={this.onClose}></i>
                        </div>
                        <div className="modal-subheader">
                            {recipients.map(r => r.displayName).join(" & ")}
                        </div>
                        <div className="modal-section">
                            <div className="split-cards flex-justify" style={{marginTop: "16px"}}>
                                {duplicatesDetails.loading ? <div className="full-width"><LoadingSpinner height="30" /></div> : recipients.map((recipient, index) =>
                                    <div key={recipient.applicantId}
                                        className={`card card-${index % 2 === 0 ? "left" : "right"} merge-card column-half`}>

                                        <p className="card-header">{recipient.displayName}</p>
                                        <div className="card-person-info">
                                            <p className="medium-text flex">
                                                <i className="icons ion-ios-telephone-outline"></i>
                                                {[recipient.phoneNumber, recipient.secondPhoneNumber].filter(p => p).join(' | ')}
                                            </p>
                                            <p className="medium-text flex">
                                                <i className="icons ion-ios-home-outline"></i>
                                                {recipient.addressDisplay}
                                            </p>
                                            {recipient.campaignList && <p className="medium-text flex">
                                                <i className="icons ion-ios-briefcase-outline"></i>
                                                {recipient.campaignList}
                                            </p>}
                                        </div>
                                        {recipient.tags.map(tag => <div key={tag.key} className="chip name-chip">
                                            <span>{tag.value}</span>
                                        </div>)}
                                        <hr />

                                        {recipient.references.length > 0 && <div>
                                            <label className="input-label">References:</label>
                                            {recipient.references.map(reference => <div key={reference.referenceId}
                                                className="application-details-personal-info">
                                                {reference.displayName && <p className="small-text">
                                                    <i className="icons ion-ios-person-outline accent-text2" />
                                                    {reference.displayName}
                                                </p>}
                                                {reference.relationship && <p className="small-text">
                                                    <i className="icons ion-ios-information-outline accent-text2" />
                                                    {reference.relationship}
                                                </p>}
                                                {(reference.phoneNumber || reference.secondPhoneNumber) && <p className="small-text">
                                                    <i className="icons ion-ios-telephone-outline accent-text2" />
                                                    {[reference.phoneNumber, reference.secondPhoneNumber].filter(p => p).join(' | ')}
                                                </p>}
                                                {reference.email && <p className="small-text">
                                                    <i className="icons ion-ios-email-outline accent-text2" />
                                                    {reference.email}
                                                </p>}
                                                {reference.addressDisplay && <p className="small-text">
                                                    <i className="icons ion-ios-location-outline accent-text2" />
                                                    {reference.addressDisplay}
                                                </p>}
                                            </div>)}
                                        </div>}

                                        <div key={recipient.applicantId} className="custom-check-container name-check-container">
                                            <input type="checkbox" id={`select-keep-${recipient.applicantId}`}
                                                className="custom-check input"
                                                checked={keepRecipientId === recipient.applicantId}
                                                onChange={() => this.toggleSelectRecipient(recipient.applicantId)} />
                                            <label htmlFor={`select-keep-${recipient.applicantId}`} className="secondary-text input">Use this Recipient</label>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {mergingDuplicates.loading ? <LoadingSpinner height="20" alignRight={true} /> :
                            <div className="modal-btns text-right">
                                <button className="btn btn-accent" onClick={this.onClose}>Cancel</button>
                                <button className="btn btn-primary" disabled={!keepRecipientId}
                                    onClick={this.mergeRecipients}>Merge</button>
                                <FadeOutErrorMessage show={!mergingDuplicates.success} message={mergingDuplicates.message} />
                            </div>}
                    </div>
                </div>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/manageDuplicates/MergeDuplicatesModal.jsx